module.exports = __webpack_public_path__ + "img/honor-3.b9d44f8e.png";